exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\n.content-area {\n  padding-bottom: 140px !important; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/ms3-web-beta-manual/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!/var/lib/jenkins/workspace/ms3-web-beta-manual/node_modules/postcss-loader?{"ident":"postcss"}!/var/lib/jenkins/workspace/ms3-web-beta-manual/node_modules/sass-loader/lib/loader.js?{"sourceMap":false,"precision":8,"includePaths":[]}!/var/lib/jenkins/workspace/ms3-web-beta-manual/src/styles.scss
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../sass-loader/lib/loader.js?{"sourceMap":false,"precision":8,"includePaths":[]}!../../../../../src/styles.scss
// module chunks = styles